import { ActionItem } from '../ActionItem';
import { CheckboxItem } from '../CheckboxItem';
import { Divider } from '../Divider';
import { NewEntryItem } from '../NewEntryItem';
import { OptionItem } from '../OptionItem';
import { ActionListItem, ItemType } from '../type';

export function itemMatcher<T>(
  item: ActionListItem<T>,
  close: () => void,
  small?: boolean,
  active?: boolean,
  index?: number,
): React.ReactElement<any, React.JSXElementConstructor<any>> | undefined {
  if (item.hide) {
    return undefined;
  }
  const key = `${item.label}-${index}`;
  switch (item.type) {
    case ItemType.Action:
      return (
        <ActionItem small={small} key={key} {...item} closeActionList={close} active={active} />
      );
    case ItemType.Option:
      return (
        <OptionItem small={small} key={key} {...item} closeActionList={close} active={active} />
      );
    case ItemType.Divider:
      return <Divider key={key} />;
    case ItemType.NewEntry:
      return (
        <NewEntryItem key={key} small={small} {...item} closeActionList={close} active={active} />
      );
    case ItemType.Checkbox:
      return <CheckboxItem small={small} key={key} {...item} active={active} />;
    case ItemType.Custom:
      return <div key={key}>{item.render()}</div>;
    case ItemType.CustomAction:
      return <div key={key}>{item.render({ active: !!active })}</div>;
    default:
      return undefined;
  }
}
